import { useContext } from "react";
import { PartogramFetusContext } from "@/contexts/PartogramFetusContext";

export function usePartogramFetus() {
	const value = useContext(PartogramFetusContext);

	return value;
}
